import { render, staticRenderFns } from "./NoQuotePage.vue?vue&type=template&id=1a210d60&scoped=true&"
import script from "./NoQuotePage.vue?vue&type=script&lang=js&"
export * from "./NoQuotePage.vue?vue&type=script&lang=js&"
import style0 from "./NoQuotePage.vue?vue&type=style&index=0&id=1a210d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a210d60",
  null
  
)

export default component.exports